import { useFormik } from "formik";
import React from "react";
import { Helmet } from "react-helmet";
import { useAccountID } from "../store/account";
import { useShow, useShowID, useUpdateShow } from "../store/show";

export default function ShowInfo() {
    return (
        <>
            <Helmet>
                <title>Show Info - Podtrac</title>
            </Helmet>
            <h1>Show Info</h1>
            <ShowInfoForm />
        </>
    );
}

function ShowInfoForm() {

    const accountID = useAccountID();
    const showID = useShowID();

    const { data: { showName, showIDDecrypted } = {} } = useShow(accountID, showID);
    const updateShow = useUpdateShow(accountID, showID);

    const validate = values => {
        const errors = {};

        if (!values.title) {
            errors.title = "Required";
        } else if (values.title.length > 150) {
            errors.title = "Must be 150 characters or less";
        }

        return errors;
    };

    const formik = useFormik({
        initialValues: {
            title: showName ?? ""
        },
        onSubmit: values => updateShow.mutateAsync(values),
        enableReinitialize: true,
        validate
    });

    return (
        <form className="form" onSubmit={formik.handleSubmit}>
            <label className="label">Show ID</label>
            <div className="field">
                <input type="text" disabled defaultValue={showIDDecrypted} />
            </div>
            <label className="label">Show Name</label>
            <div className="field">
                <input
                    id="title"
                    name="title"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    className={
                        formik.touched.title && formik.errors.title ? "error" : null
                    }
                />
                {formik.touched.title && formik.errors.title ? (
                    <div className="error">{formik.errors.title}</div>
                ) : (
                    <div className="info">The name displayed on the dashboard for this show</div>
                )}
            </div>
            <div className="buttons">
                <button type="submit" disabled={formik.isSubmitting}>
                    Save
                </button>
            </div>
        </form>
    );
}
